




















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppArchiveCard from '~/components/partials/App/AppArchiveCard.vue';
import AppArticleCardSimple from '~/components/partials/App/AppArticleCardSimple.vue';
import { ArticleCard } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppArchiveCard,
    AppArticleCardSimple,
  },
  props: {
    articles: {
      type: Array as PropType<ArticleCard[]>,
      required: true,
    },
    isMagazine: {
      type: Boolean,
      default: false,
    },
  },
});
